<template>
  <div class="etrail-block">
    <b-form class="etrail-form">
      <b-row class="mt-2">
        <b-col>
          <label>Booking reference</label>
          <div class="pts-readonly-field">
            {{ booking.user_information.bookingNumber }}
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <label>Submitted by</label>
          <b-form-select
            id="pts-select-passenger"
            :value="form.passenger"
            @change="onPassengerChange"
          >
            <option :value="null">Please select a name...</option>
            <option v-for="(item, index) in paxNames" :key="index" :value="item">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <label>Email (edit as required)</label>
          <b-form-input
            id="pts-input-email"
            type="email"
            :value="form.email"
            :state="emailState"
            class="mb-2"
            @input="val => emit('email', val)"
          />
          <b-form-invalid-feedback>
            Please enter a valid email address.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <label>Preferred contact number (edit as required)</label>
          <b-form-select
            v-if="phoneOptions.length && !manualPhone"
            :value="form.tel1"
            :options="[...phoneOptions, { text: 'Enter a different number', value: '__manual__' }]"
            @change="onPhoneOptionChange"
          />
          <b-form-input
            v-else
            id="pts-input-tel"
            :value="form.tel1"
            type="text"
            class="mb-2"
            @input="val => emit('tel1', val)"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    booking: { type: Object, required: true },
    paxNames: { type: Array, default: () => [] },
    form: { type: Object, required: true },
  },
  data() {
    return {
      manualPhone: false,
    }
  },
  computed: {
    emailState() {
      if (!this.form.email || this.form.email.includes('*')) return null
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email) ? null : false
    },
    phoneOptions() {
      if (!this.form.passenger) return []
      const isPlaceholder = (num) => {
        const stripped = num.replace(/\s+/g, '').toLowerCase()
        return stripped === 'pleaseadvise' || /^ple\*+ise$/i.test(stripped)
      }
      const tel = this.form.passenger.tel
      if (!tel || !tel.trim() || isPlaceholder(tel)) return []
      return [{ text: tel.trim(), value: tel.trim() }]
    },
  },
  methods: {
    emit(field, value) {
      this.$emit('update', { [field]: value })
    },
    onPassengerChange(passenger) {
      this.manualPhone = false
      this.$emit('update', {
        passenger,
        email: passenger ? passenger.email : '',
        tel1: passenger ? passenger.tel || '' : '',
      })
    },
    onPhoneOptionChange(val) {
      if (val === '__manual__') {
        this.manualPhone = true
        this.$emit('update', { tel1: '' })
      } else {
        this.$emit('update', { tel1: val })
      }
    },
  },
}
</script>
